import { render } from "./userTeamScore.vue?vue&type=template&id=b8995434&scoped=true"
import script from "./userTeamScore.vue?vue&type=script&lang=js"
export * from "./userTeamScore.vue?vue&type=script&lang=js"

import "./userTeamScore.vue?vue&type=style&index=0&id=b8995434&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8995434"]])

export default __exports__